.statusDot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: var(--radius-circle);
  flex-shrink: 0;
  /* Small primitive: no transition on colour. A tone change follows a real
   * state change (the stream dropped), so it should read as instant, and the
   * theme swap must stay in lockstep with every other token-driven colour. */
}

/* Figma spec: --green-500 (#10b981) in light, --green-400 (#34d399)
 * in dark. The existing --brand token uses #10b981 in
 * BOTH light and dark mode, so plugging it in would silently lose
 * the dark-mode shift to #34d399. Hardcode both literals here until
 * design exposes a dedicated --status-dot-color alias that carries
 * the correct per-mode values — then swap the two literals in one
 * pass. Do NOT "simplify" this to var(--brand): that
 * token stays at #10b981 in dark mode and would break the shift. */
.positive {
  background: #10b981;
}

/* TODO: remove when --status-dot-color semantic alias lands. */
[data-theme="dark"] .positive {
  background: #34d399;
}

/* Amber from the raw primitive ramp in tokens-extensions.css. Darker step in
 * light, lighter in dark — the same direction the green above shifts, so the
 * dot keeps a consistent weight against the header surface in both themes. */
.warning {
  background: var(--amber-600);
}

[data-theme="dark"] .warning {
  background: var(--amber-300);
}

/* De-emphasised foreground: present enough to read as "a dot that is not
 * green", quiet enough not to look like an error. Flips with the theme on
 * its own, so no dark-mode override. */
.neutral {
  background: var(--text-tertiary);
}

/* Slow pulse for a state that is actively trying to recover. This is the only
 * signal separating "reconnecting" from "not connected" — with the label kept
 * sr-only, a static amber dot and a static grey dot differ by hue alone. */
.pulse {
  animation: statusDotPulse 2s ease-in-out infinite;
}

@keyframes statusDotPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

/* Motion is decoration here — the tone still carries the state. */
@media (prefers-reduced-motion: reduce) {
  .pulse {
    animation: none;
  }
}
